import React from 'react';
import Icon from '../AppIcon';

const SyncStatusBadge = ({ status = 'synced', size = 'sm', showLabel = true }) => {
  const configs = {
    syncing: {
      icon: 'RefreshCw',
      label: 'Syncing',
      color: 'text-warning',
      bgColor: 'bg-warning/10',
      borderColor: 'border-warning/20',
      animate: true
    },
    synced: {
      icon: 'CheckCircle2',
      label: 'Synced',
      color: 'text-success',
      bgColor: 'bg-success/10',
      borderColor: 'border-success/20',
      animate: false
    },
    error: {
      icon: 'AlertCircle',
      label: 'Error',
      color: 'text-error',
      bgColor: 'bg-error/10',
      borderColor: 'border-error/20',
      animate: false
    }
  };

  const config = configs?.[status] || configs?.synced;
  
  const sizeClasses = {
    xs: {
      container: 'px-1.5 py-0.5 text-[10px]',
      icon: 10,
      gap: 'space-x-0.5'
    },
    sm: {
      container: 'px-2 py-1 text-xs',
      icon: 12,
      gap: 'space-x-1'
    },
    md: {
      container: 'px-2.5 py-1.5 text-sm',
      icon: 14,
      gap: 'space-x-1.5'
    }
  };

  const sizeConfig = sizeClasses?.[size] || sizeClasses?.sm;

  return (
    <div 
      className={`inline-flex items-center ${sizeConfig?.gap} ${sizeConfig?.container} rounded-full ${config?.bgColor} ${config?.color} border ${config?.borderColor} font-medium transition-all duration-200`}
      title={config?.label}
    >
      <Icon 
        name={config?.icon} 
        size={sizeConfig?.icon} 
        className={`${config?.color} ${config?.animate ? 'animate-spin' : ''}`}
      />
      {showLabel && (
        <span className="whitespace-nowrap">{config?.label}</span>
      )}
    </div>
  );
};

export default SyncStatusBadge;